import React from 'react';

import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/services/utils';

import { Badge } from '../Badge';

type LabelPanelProps = {
    icon?: React.ElementType;
    titleOne: string;
    titleTwo?: string;
    titleOneHasMaxWidth?: boolean;
    backgroundClassName?: string;
    noPadding?: boolean;
    badgeTitle?:string;
    variant?: 'info' | 'success' | 'error' | 'warning' | 'neutral',
};

const LabelPanel: React.FC<LabelPanelProps> = ({
    icon: Icon,
    titleOne,
    titleTwo,
    titleOneHasMaxWidth = false,
    backgroundClassName,
    noPadding,
    badgeTitle,
    variant= 'info'
}) => {
    const { t } = useTranslation();
    return (
        <div className={cn('tw-inline-flex tw-items-center tw-gap-2 tw-bg-gray-100 tw-rounded',
            !noPadding && 'tw-px-3 tw-py-2',
            backgroundClassName
        )}>
            <div
                className={cn(
                    'tw-inline-flex tw-items-center tw-justify-center tw-gap-1',
                    'smaller:tw-inline-flex sm:tw-justify-center smaller:tw-items-center',
                    'tw-text-t-sm',
                    'font-dynamic',
                    'lg-font-dynamic',
                )}
            >
                {Icon && <Icon className="tw-gap-1 tw-w-5 tw-h-5 lg-icon-dynamic tw-text-t-primary" />}
                <div title={titleOne}
                    className={`
                    tw-truncate tw-overflow-hidden tw-text-t-primary tw-whitespace-nowrap
                    ${titleOneHasMaxWidth ? 'width-fix lg-width-fix' : ''}
                `}
                >
                    {titleOne}
                </div>
                {titleTwo && (
                    <span className="tw-whitespace-nowrap tw-text-t-primary tw-flex-shrink-0">{titleTwo}</span>
                )}
            </div>
            {  badgeTitle &&
                <Badge type='status' variant={ variant } >{t(badgeTitle)}</Badge>
            }
        </div>

    );
};

export default LabelPanel;
